// Phase C.1b — shared Career Mode metadata: the single place display
// label/emoji/description/tagline live for the four modes, reused by the
// landing page, account settings, and the Navbar mode switcher so all
// three never drift out of sync. 'director'/'admin'/'platform_admin' are
// NEVER valid entries here — see migration 037's own header for why
// Program/Team/Platform authority is a completely separate concept from
// Career Mode (an experience preference, not an authorization grant).
export const CAREER_MODES = ['fan', 'athlete', 'guardian', 'coach'];

export const CAREER_MODE_META = {
  fan: {
    label: 'Fan',
    emoji: '📣',
    tagline: 'Follow.',
    description: 'Follow programs, teams, results, events, and the football community.',
  },
  athlete: {
    label: 'Athlete',
    emoji: '🏃',
    tagline: 'Develop.',
    description: 'Track your development, personal bests, training, team, and football knowledge.',
  },
  guardian: {
    label: 'Parent / Guardian',
    emoji: '👨‍👩‍👧',
    tagline: 'Support.',
    description: 'Support your athletes and stay connected to their teams, schedules, and development.',
  },
  coach: {
    label: 'Coach',
    emoji: '🧢',
    tagline: 'Lead.',
    description: 'Develop athletes, teach football, and manage your team.',
  },
};

export function careerModeLabel(mode) {
  return CAREER_MODE_META[mode]?.label || mode;
}
